import React from "react";
import pkg from "../../../package.json";

const envVersion = process.env.REACT_APP_VERSION;
const pkgVersion = pkg.version;
const version = envVersion || pkgVersion || "v?";

const style = {
  position: "fixed",
  bottom: 4,
  left: 8,
  fontSize: "12px",
  color: "#555",
  fontFamily: "Arial, sans-serif",
  opacity: 0.8,
  userSelect: "none",
  zIndex: 9999
};

export default function VersionStamp() {
  return <div style={style}>Version {version}</div>;
}
